export enum NetworkUserStatus {
  friend = 'friend',
  incoming = 'incoming',
  contact = 'contact',
  future_outgoing = 'future_outgoing',
  outgoing = 'outgoing',
  incoming_contact = 'incoming_contact',
}
